export const FALLBACK_ISSUER = "Il Professionista";
const ART = { di: "del", a: "al", da: "dal" };

export const withPrep = (prep, name = FALLBACK_ISSUER) =>
  name === FALLBACK_ISSUER ? `${ART[prep]} Professionista` : `${prep} ${name}`;
